export const getCombinedName = ({ salutation, firstName, lastName, organizationName }: any) => {
  if (salutation && lastName) {
    return `${salutation} ${lastName}`;
  } else if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  } else if (organizationName) {
    return organizationName;
  }
  return '';
};
